// src/components/admin/AdminDashboard.js
import React, { useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import { pageMeta } from "../../config/helmetConfig";
import { updateMetaTags } from "../../utils/metaManager";

export default function AdminDashboard() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    updateMetaTags(pageMeta.admin);
  }, []);
  // Admin management areas
  const managementAreas = [
    {
      id: "services",
      title: "Services",
      description: "Manage salon services and treatments",
      icon: "✂️",
      route: "/admin/services",
    },
    {
      id: "events",
      title: "Events",
      description: "Manage upcoming events and classes",
      icon: "📅",
      route: "/admin/events",
    },
    {
      id: "team",
      title: "Team Members",
      description: "Manage staff profiles",
      icon: "👥",
      route: "/admin/team",
    },
    {
      id: "images",
      title: "Images",
      description: "Manage website images and gallery",
      icon: "🖼️",
      route: "/admin/images",
    },
  ];

  return (
    <Container className="py-4">
      <Row className="mb-4">
        <Col>
          <h1 className="text-light">Admin Dashboard</h1>
          <p className="text-light">Welcome, {currentUser?.username}</p>
        </Col>
      </Row>

      <Row xs={1} sm={2} lg={4} className="g-4">
        {managementAreas.map((area) => (
          <Col key={area.id}>
            <Card
              className="h-100 bg-dark text-white border-secondary hover-card"
              onClick={() => navigate(area.route)}
              style={{ cursor: "pointer", width: "100%" }}
            >
              <Card.Body className="d-flex flex-column align-items-center text-center">
                <div className="icon-container mb-3 fs-1">{area.icon}</div>
                <Card.Title>{area.title}</Card.Title>
                <Card.Text>{area.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Add some custom CSS for the hover effect */}
      <style jsx>{`
        .hover-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </Container>
  );
}
